import { CrudBuilderConfig } from '@core/components/crudbuilder/models/crud-builder-config';
import { FieldConfig } from '@core/components/crudbuilder/models/field-config';
import { BreadBuilderService } from '@core/services/bread-builder/bread-builder.service';
import { PopularAppStatesService } from '@core/services/popular-app-states/popular-app-states.service';
import { MortgagesCrudBuilderConfig } from '@core/pages/crud/mortgages-crud-builder-config';

export class MortgageStepConfig extends CrudBuilderConfig {
  title       = 'Hypotheek';
  singular    = 'Hypotheek';
  plural      = 'Hypotheken';
  getEndpoint = 'mortgages';
  putEndpoint = 'mortgages';
  multiEdit   = true;
  icon        = 'building';
  path        = 'mortgage';
  modelAlias  = 'mortgage';

  fields = MortgagesCrudBuilderConfig.fields;

  runBeforeSaving(model, s: BreadBuilderService): any {
    // We just add the person id over here
    const acc = s.states.account.getCached();
    model.person_id = acc.id;
    return super.runBeforeSaving(model, s);
  }

  getReadTitle(model): string {
    if (model) {
      return model.name;
    }
  }

  hasCustomBackRoute = true;
  getCustomBackRoute() {
    return '/dashboard/fixed-charges';
  }

  runBeforeSavingOnAddView(model, s: PopularAppStatesService = null): any {
    const acc = s.account.getCached();
    model.person_id = acc.id;
    return super.runBeforeSavingOnEditView(model, s);
  }
}

export const MortgageStep = new MortgageStepConfig();
